export const Roles = {
    ops: 'ops',
    sales_person: 'sales_person',
    financer: 'financer',
    advertiser: 'advertiser',
    network_ad_manager: "w@y2n3m$Ad$-NAM",
    b2b: "b2b",
    legalperson: "w@y2n3m$Ad$-LGL"
};

